import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import baseURL from '../../../../Apiurs/Apiurls';
import Navbar from '../../../../Shared/AdminNavbar/Navbar';


const StockOut = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [formData, setFormData] = useState({
    quantity: '',
    reason: 'sale',
    reference_number: '',
    notes: '',
  });
  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false); // State for sidebar toggle

  useEffect(() => {
    fetchProduct();
  }, [id]);

  const fetchProduct = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/product/${id}`);
      setProduct(res.data);
    } catch (err) {
      console.error('Error fetching product:', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (parseInt(formData.quantity) > (product.Quantity || 0)) {
      alert('Insufficient stock available!');
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${baseURL}/api/stock/out`, {
        detail_id: id,
        quantity: parseInt(formData.quantity),
        reason: formData.reason,
        reference_number: formData.reference_number,
        notes: formData.notes,
      });

      alert('Stock removed successfully!');
      navigate('/products');
    } catch (err) {
      alert('Error: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  if (!product) return <div>Loading...</div>;

  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? 'collapsed' : ''}`}>
        <div className="container mt-4">
          <div className="card">
            <div className="card-header">
              <h4>Stock Out - {product.batch}</h4>
              <p className="mb-0">Batch: {product.batch} | Size: {product.size}</p>
            </div>
            <div className="card-body">
              <div className="mb-3">
                <strong>Current Stock:</strong> {product.Quantity || 0}
              </div>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Quantity *</label>
                      <input
                        type="number"
                        className="form-control"
                        value={formData.quantity}
                        onChange={(e) => setFormData({ ...formData, quantity: e.target.value })}
                        min="1"
                        max={product.Quantity || 0}
                        required
                      />
                      <small className="text-muted">
                        Maximum available: {product.Quantity || 0}
                      </small>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Reason *</label>
                      <select
                        className="form-select"
                        value={formData.reason}
                        onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
                        required
                      >
                        <option value="sale">Sale</option>
                        <option value="damage">Damage</option>
                        <option value="return">Return to Supplier</option>
                        <option value="adjustment">Stock Adjustment</option>
                      </select>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Reference Number</label>
                      <input
                        type="text"
                        className="form-control"
                        value={formData.reference_number}
                        onChange={(e) => setFormData({ ...formData, reference_number: e.target.value })}
                        placeholder="Sales Order No, etc."
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Notes</label>
                      <textarea
                        className="form-control"
                        value={formData.notes}
                        onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                        rows="4"
                        placeholder="Additional notes..."
                      />
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-2">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => navigate('/products')}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-warning"
                    disabled={loading}
                  >
                    {loading ? 'Removing Stock...' : 'Remove Stock'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockOut;